module.exports = __webpack_public_path__ + "assets/img/safe_icon0.b551717e.png";